import React from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import Brand from '../../menhomethree/Brand'
import First from '../menphdlist/First'
import NewMain from '../../headerone/newMain'
function Main() {
  return (
    <>
        <NewMain/>
        <Bredcom title="Home" subtitle="List of Ph.D Research Scholars"/>
        <First/>
        {/* <Brand/> */}
    </>
  )
}

export default Main